import { render, staticRenderFns } from "./BnftProgress.vue?vue&type=template&id=8892e6b0&scoped=true&"
import script from "./BnftProgress.vue?vue&type=script&lang=js&"
export * from "./BnftProgress.vue?vue&type=script&lang=js&"
import style0 from "./BnftProgress.vue?vue&type=style&index=0&id=8892e6b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8892e6b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VOverlay,VProgressCircular})
